import React from "react";
import side_image from "../../Assets/multifancy12.gif"; // Replace with your GIF path
import "./WelcomeSection.css";

const WelcomeSection = ({ homeData }) => (
  <div className="vb-welcome">
    <div className="vb-container">
      {/* LEFT – Dark background area for GIF visibility */}
      <div className="vb-visual">
        <div className="vb-image-wrapper">
          <div className="vb-image-frame">
            <img
              src={side_image}
              alt="Yuvathi Sparks Fireworks"
              className="vb-image"
            />
          </div>
          {/* Glow rings */}
          <div className="vb-glow-ring vb-glow-ring--1"></div>
          <div className="vb-glow-ring vb-glow-ring--2"></div>
          <div className="vb-glow-ring vb-glow-ring--3"></div>
          {/* Floating sparkle particles */}
          <span className="vb-sparkle vb-sparkle--1"></span>
          <span className="vb-sparkle vb-sparkle--2"></span>
          <span className="vb-sparkle vb-sparkle--3"></span>
          <span className="vb-sparkle vb-sparkle--4"></span>
        </div>
      </div>

      {/* RIGHT – Vibrant content area */}
      <div className="vb-content">
        <span className="vb-tag">✦ EST. 2015</span>
        <h2 className="vb-subhead">Welcome to the family</h2>
        <h1 className="vb-headline">
          <span className="vb-brand-accent">Yuvathi</span>{" "}
          <span className="vb-brand">Sparks</span>
        </h1>
        <div className="vb-location">
          <i className="fas fa-map-marker-alt"></i> Wholesale &amp; Retail in <strong>Sivakasi</strong>
        </div>
        <div className="vb-description" dangerouslySetInnerHTML={{ __html: homeData.value }} />
        <div className="vb-features">
          <div className="vb-feature-item">
            <div className="vb-feature-icon">★</div>
            <span>Premium Quality</span>
          </div>
          <div className="vb-feature-item">
            <div className="vb-feature-icon">⚡</div>
            <span>Timely Delivery</span>
          </div>
          <div className="vb-feature-item">
            <div className="vb-feature-icon">₹</div>
            <span>Best Prices</span>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default WelcomeSection;